import { InputStateToken } from '@voltmoney/schema';
import SharedPropsService from '../../../SharedPropsService';
import { ELIGIBLE_LIMIT, getParameters, getTargetParamFromURL, nextStepId, phonePayRoutes, removePathFromUrlWithouReload, showSupportNUmberForPartner, showSupportNumberForAllCustomer, switchToSpecificRoutes, } from '../../../configs/utils';
import { api, partnerApi } from '../../../configs/api';
import { getAppHeader, getAuthHeaders } from '../../../configs/config';
import _ from 'lodash';
import { ROUTE } from '../../../routes';
import { APPLICATION_STATE, LENDER_ID, QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import { Platform } from 'react-native';
import { MutualAmountValueToBackend } from '../../AskMutualFund/askMutualFund/types';
import sharedPropsService from "../../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
let isDisabled = false;
export const checkUserType = async (action, _datastore, { ...props }) => {
    const userType = await SharedPropsService.getUserType();
    switch (userType) {
        case 'PARTNER':
            await partnerLogin(action, {}, props);
            break;
        case 'BORROWER':
            await login(action, {}, props);
            break;
    }
};
export const partnerLogin = async (action, _datastore, { navigate, setDatastore, network }) => {
    if (action.payload.value.length !== 4)
        return;
    await setDatastore(action.routeId, action.payload.widgetId, {
        state: InputStateToken.LOADING,
    });
    const loginResponse = await network.post(api.verifyOtp, {
        otp: action.payload.value,
        phoneNo: action.payload.username,
    });
    if (_.get(loginResponse, 'status') === 200) {
        await setDatastore(action.routeId, action.payload.widgetId, {
            state: InputStateToken.SUCCESS,
        });
        await sharedPropsService.setToken(loginResponse.data.jwt);
        const userContextResponse = await network.post(partnerApi.userContext, {}, { headers: await getAppHeader() });
        const user = userContextResponse.data;
        await SharedPropsService.setUser(user);
        await navigate(ROUTE.ENTER_NAME);
    }
    else {
        await setDatastore(action.routeId, action.payload.widgetId, {
            state: InputStateToken.ERROR,
            caption: { error: loginResponse.data.message },
        });
    }
};
export const login = async (action, _datastore, { navigate, setDatastore, instrumentTrack, network, navigateWithClear, initializeAmplitude, }) => {
    const noOfOtpDigits = action.payload.noOfOtpDigits;
    // await sharedPropsService.setPledgeData(undefined)
    if (action.payload.value.length !== noOfOtpDigits)
        return;
    if (isDisabled)
        return;
    await setDatastore(action.routeId, "otpverifyScreen", {
        state: InputStateToken.DEFAULT,
    });
    const loginResponse = await network.post(api.verifyOtp, {
        otp: action.payload.value,
        phoneNo: action.payload.username,
    }, { headers: await getAuthHeaders(), handleFromMF: true });
    if (_.get(loginResponse, 'status') === 200) {
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const utmCampaign = params?.utm_source;
        const isFromPhonePe = params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */;
        await SharedPropsService.setToken(loginResponse.data.jwt);
        if (Platform.OS === 'web') {
            removePathFromUrlWithouReload("?startnew=true");
        }
        if (Platform.OS === 'web') {
            await AsyncStorage.setItem("accessToken", loginResponse?.data?.jwt);
        }
        await setDatastore(action.routeId, "otpverifyScreen", {
            state: InputStateToken.SUCCESS,
        });
        if (action.payload.leadId) {
            const leadResponse = await network.post(`${api.ConvertALeadToBorrower}${action.payload.leadId}`, {}, {
                headers: await getAppHeader()
            });
        }
        const userContextResponse = await network.post(api.userContext, {
            onboardingPartnerCode: await SharedPropsService.getPartnerRefCode(),
        }, { headers: await getAppHeader() });
        const user = userContextResponse.data;
        const applicationState = user?.linkedApplications[0]?.applicationState;
        if (Platform.OS === 'web') {
            try {
                const currentApplicationState = await AsyncStorage.getItem("applicationState");
                if (currentApplicationState === APPLICATION_STATE.IN_PROGRESS && applicationState === APPLICATION_STATE.COMPLETED) {
                    await AsyncStorage.setItem("applicationState", applicationState);
                }
                else if (!currentApplicationState) {
                    await AsyncStorage.setItem("applicationState", applicationState);
                }
            }
            catch (error) {
                console.error("Error saving application state", error);
            }
        }
        initializeAmplitude(user.linkedApplications[0].accountId);
        await SharedPropsService.setUser(user);
        action?.payload?.setIsUserLoggedIn(user);
        if (Platform.OS === 'web') {
            action?.payload?.setApplicationState(applicationState);
        }
        const pledgeLimitResponse = await network.get(`${api.pledgeLimit}${user.linkedApplications[0].applicationId}`, { headers: await getAppHeader() });
        const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount ||
            0;
        const totalPortfolioAmount = pledgeLimitResponse.data.stepResponseObject.totalPortfolioAmount ||
            0;
        const showSupportNumber = await showSupportNumberForAllCustomer(user);
        const showSupportNUmberForPartnerCustomer = await showSupportNUmberForPartner();
        if (availableCreditAmount >= ELIGIBLE_LIMIT.MIN_LIMIT || totalPortfolioAmount >= ELIGIBLE_LIMIT.MAX_AMOUNT || showSupportNumber) {
            if (Platform.OS === 'web') {
                action?.payload?.setShowSupportPhoneNumber(true);
            }
            await SharedPropsService.setSupportPhoneNumber(true);
        }
        else {
            if (Platform.OS === 'web') {
                action?.payload?.setShowSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
            }
            await SharedPropsService.setSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
        }
        let nextRoute = {};
        let isFromBajaj = user?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ;
        if (await SharedPropsService.showHome()) {
            if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */) {
                nextRoute = await nextStepId(user.linkedApplications[0].currentStepId);
                if (phonePayRoutes.includes(nextRoute.routeId)) {
                    nextRoute = await nextStepId(user.linkedApplications[0].currentStepId, "Landing_Page");
                }
                else {
                    return navigate(ROUTE.PHONE_PAY_PAGE);
                }
            }
            nextRoute = await nextStepId(user.linkedApplications[0].currentStepId, "Landing_Page");
        }
        else {
            nextRoute = await nextStepId(user.linkedApplications[0].currentStepId);
            if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && utmCampaign !== QUERY_PARAMS.PHONE_PE_FJ) {
                if (phonePayRoutes.includes(nextRoute.routeId)) {
                    nextRoute = await nextStepId(user.linkedApplications[0].currentStepId, "Landing_Page");
                }
                else {
                    return navigate(ROUTE.PHONE_PAY_PAGE);
                }
            }
            else if (isFromPhonePe && isFromBajaj && !phonePayRoutes.includes(nextRoute.routeId)) {
                return navigate(ROUTE.PHONE_PAY_PAGE);
            }
        }
        if (nextRoute.routeId === ROUTE.EMAIL_VERIFY) {
            const userId = user.user.userId;
            const shouldShowAskMutualFund = await network.get(`${api.securityAssetConsent}${userId}`, { headers: await getAppHeader() });
            const getUserAttributes = await network.get(`${api.userAttributes}${userId}`, { headers: await getAppHeader() });
            const shouldCheckConsent = shouldShowAskMutualFund.data.shouldCheckConsent;
            const existingConsent = shouldShowAskMutualFund.data.existingConsent;
            const isAmountSelected = getUserAttributes.data.assetRange;
            const showAskMF = await sharedPropsService.getShowAskMF();
            if (showAskMF) {
                if (shouldCheckConsent && utmCampaign === 'Facebook') {
                    await navigateWithClear(ROUTE.ASK_MUTUAL_FUND_OLD);
                }
                else if (isAmountSelected === null && existingConsent === 'YES') {
                    await navigateWithClear(ROUTE.ASK_MUTUAL_FUND);
                }
                else if (existingConsent === 'NO' ||
                    (isAmountSelected === MutualAmountValueToBackend.AMOUNT_0K &&
                        existingConsent === 'NO')) {
                    await navigateWithClear(ROUTE.NO_MUTUAL_FUND_INSTRUCTION);
                }
                else if ((isAmountSelected === MutualAmountValueToBackend.AMOUNT_0K &&
                    existingConsent === 'YES') ||
                    (nextRoute.routeId === ROUTE.NO_MUTUAL_FUND_INSTRUCTION &&
                        isAmountSelected === null &&
                        existingConsent === 'YES')) {
                    await navigate(nextRoute.routeId, nextRoute.params);
                }
            }
            else {
                await navigate(nextRoute.routeId, nextRoute.params);
            }
        }
        else {
            if (user.linkedApplications[0].applicationState === 'COMPLETED') {
                if (params?.showPostLoanJourney === 'false' || params?.platform === "BHARAT_PE" || params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */) {
                    return navigate(ROUTE.CREDIT_LOADING_SCREEN, { showDownloadAppScreen: true });
                }
                if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ &&
                    utmCampaign !== QUERY_PARAMS.PHONE_PE_FJ) {
                    return navigate(ROUTE.PHONE_PAY_PAGE);
                }
                const target = getTargetParamFromURL();
                let availableCreditAmount;
                if (target === TARGET_PAGES.WITHDRAW) {
                    const response = await network.get(`${api.getCredit}/${userContextResponse.data.linkedCredits[0].creditId}`, {
                        headers: await getAppHeader(),
                    });
                    availableCreditAmount =
                        response.data.availableCreditAmount > 0;
                }
                await switchToSpecificRoutes(userContextResponse.data, availableCreditAmount, navigate);
            }
            else {
                await navigateWithClear(nextRoute.routeId, nextRoute.params);
            }
        }
    }
    else {
        //update to error state
        if (loginResponse.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            isDisabled = true;
            await setDatastore(ROUTE.OTP_VERIFY, "otpverifyScreen", {
                state: InputStateToken.DISABLED,
                caption: { error: loginResponse.response.data.message },
                otpLimitExceeded: true
            });
        }
        else {
            await setDatastore(ROUTE.OTP_VERIFY, "otpverifyScreen", {
                state: InputStateToken.ERROR,
                caption: { error: loginResponse.response.data.message }
            });
        }
    }
};
export const goBack = async (action, _datastore, { navigate, instrumentTrack, goBack, navigateWithClear, removeWidgets }) => {
    instrumentTrack("EDIT_PHONE_BUTTON_CLICKED");
    isDisabled = false;
    //    await removeWidgets(ROUTE.OTP_VERIFY, [
    //        {id : "otpModalScreen", type : WIDGET.OTP_MODAL_SCREEN}
    //     ])
    goBack();
};
export const editNumber = async (action, _datastore, { navigate, instrumentTrack, goBack, setDatastore }) => {
    instrumentTrack("EDIT_PHONE_BUTTON_CLICKED");
    isDisabled = false;
    let disabled = false;
    await setDatastore(ROUTE.OTP_VERIFY, "otpverifyScreen", {
        state: InputStateToken.DEFAULT,
        caption: {},
    });
    //   goBack()
    navigate(ROUTE.PHONE_NUMBER, {
        disabled,
        validNumber: true,
    });
};
